import BroadcastStatusMark, { IBroadcastStatusMarkProps } from '../index';

import { useBroadcastsStatus } from 'hooks/utils/useBroadcastsStatus';

import { BroadcastType } from 'graphql/types';

interface IBroadcastStatusWrapperProps
  extends Omit<IBroadcastStatusMarkProps, 'settings'> {
  broadcasts: BroadcastType[];
}

export default function BroadcastStatusWrapper({
  broadcasts,
  ...restProps
}: IBroadcastStatusWrapperProps) {
  const broadcastsStatusList = useBroadcastsStatus(broadcasts || []);

  return <BroadcastStatusMark settings={broadcastsStatusList} {...restProps} />;
}
